import React from "react"

import './Spinner.css'

class Spinner extends React.Component {
  render = () =>
    <div className={this.props.className ? 'spinner ' + this.props.className : 'spinner'} />
}

export default Spinner